import { splash } from './SplashScreen.css';

export const SplashScreen = () => (
  <div className={splash}>
    <img src="/logo-alt.png" />
  </div>
);
